// "Connect Instagram" (Instagram API with Instagram Login — Business/Creator
// accounts, no Facebook Page). Sends the user to IG authorize; /ig-callback
// finishes via the ig-oauth-callback edge fn. Least-privilege scopes only —
// extra scopes are the classic App Review rejection reason.
export const IG_SCOPES = 'instagram_business_basic,instagram_business_manage_insights';

export function igConfigured(): boolean {
  return Boolean(import.meta.env.VITE_IG_APP_ID);
}

export function startIgConnect(intent: 'creator' | 'brand'): boolean {
  const appId = import.meta.env.VITE_IG_APP_ID as string | undefined;
  if (!appId) return false;
  const state = `${intent}:${crypto.randomUUID()}`;
  sessionStorage.setItem('ig_connect_state', state);
  const u = new URL('https://www.instagram.com/oauth/authorize');
  u.searchParams.set('client_id', appId);
  u.searchParams.set('redirect_uri', `${window.location.origin}/ig-callback`);
  u.searchParams.set('response_type', 'code');
  u.searchParams.set('scope', IG_SCOPES);
  u.searchParams.set('state', state);
  window.location.href = u.toString();
  return true;
}
